'use strict';

import { reverseUrl } from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var MyStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('complainant contacted', Q('contacts:call_completed', 'contacts:call_skipped'))
	.add('preparing to work', Q('geo:at_shop', 'geo:at_shop_skipped'))
	.add('on-scene', Q('geo:arrived'))
	.add('departed', Q('geo:departed'))
	.add('team done', Q('team:done', 'geo:location_skipped'))
	.add('awaiting approval', Q('form_skipped'));


export default function(incident) {
	MyStateDiagram.updateIncident(incident);
	incident.phoneFromUrl =  reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
}
